import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  title: "Convolution of an acoustic signal to add reverberation",
  description:
    "Convolution is a way to add reflections to an acoustic signal. For this basic problem the impulse response of the room is synthetized based on a unique parameter: the reverberation time T in seconds. The impulse response of the room is  represented in the figure on the left and you can hear the result of the convolution of the original signal with the response of the room",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0303b/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
